const advertise = {
    dfdh: 'Telepon pihak lain:',
    sjmc: 'Nama Merchant',
    qsrsj: 'Silakan masukkan nama merchant',
    sjbzj: 'Jaminan Merchant',
    wcl: 'Tingkat Penyelesaian 30 Hari',
    zcd: 'Total Pesanan Selesai (Beli/Jual)',
    cd: 'Pesanan Selesai 30 Hari',
    c: 'kali',
    fz: 'menit',
    pjfx: 'Rata-rata Waktu Pelepasan',
    zcsj: 'Waktu Pendaftaran:',
    fbjy: 'Kunjungan Pertama ke Perdagangan Fiat:',
    yxbd: 'Email Terikat',
    sjbd: 'Ponsel Terikat',
    cjsm: 'Verifikasi Identitas Dasar',
    gjsm: 'Verifikasi Identitas Lanjutan',
    buy: 'Beli',
    sell: 'Jual',
    market: 'Pasar',
    djfs: 'Metode Penetapan Harga',
    ggid: 'ID Iklan',
    time: 'Waktu',
    type: 'Tipe',
    ptgg: 'Iklan Biasa',
    gdjg: 'Harga Tetap',
    fdjg: 'Harga Mengambang',
    yjfw: 'Rentang Premium',
    unitPrice: 'Harga Satuan',
    totalPrice: 'Harga Total',
    sysl: 'Jumlah Tersisa',
    ywcsl: 'Jumlah Telah Selesai',
    cz: 'Operasi',
    xj: 'Turunkan',
    sj: 'Tampilkan',
    edit: 'Edit',
    delete: 'Hapus',
    all: 'Semua',
    qdxjm: 'Anda yakin ingin menurunkan iklan ini?',
    qdxj: 'Konfirmasi Turunkan',
    qdsjm: 'Anda yakin ingin menampilkan iklan ini?',
    qdsj: 'Konfirmasi Tampilkan',
    confirm: 'Konfirmasi',
    cancel: 'Batal',
    qdscm: 'Anda yakin ingin menghapus iklan ini?',
    deleteAdvertise: 'Hapus Iklan',

    tjgm: 'Statistik Pembelian',
    tjcs: 'Statistik Penjualan',
    coins: 'Mata Uang',
    day7: '7 Hari',
    day15: '15 Hari',
    day30: '30 Hari',
    tj: 'Statistik',
    mrsl: 'Jumlah Pembelian',
    mcsl: 'Jumlah Penjualan',
    mrjj: 'Harga Rata-rata Pembelian',
    mcjj: 'Harga Rata-rata Penjualan',
    zcje: 'Jumlah Pengeluaran',
    srje: 'Jumlah Pemasukan',
    zsxf: 'Total Biaya',
    cjdd: 'Pesanan Terselesaikan',
    zdxx: 'Informasi Tagihan',
    tips: 'Tip: Untuk setiap pasangan perdagangan, statistik beli/jual hanya dapat diekspor 100 kali per hari',
    dcdd: 'Ekspor Pesanan',
    orderNo: 'Nomor Pesanan',
    jybz: 'Mata Uang Perdagangan',
    number: 'Jumlah',
    total: 'Total',
    fee: 'Biaya',
    zd: 'Tagihan',

    tjskfs: 'Tambahkan Metode Pembayaran',
    skfs: 'Metode Pembayaran',
    name: 'Nama',
    payAccount: 'Akun',
    sk: 'Penerimaan',
    cz: 'Operasi',
    delete: 'Hapus',
    edit: 'Ubah',
    qdsc: 'Konfirmasi Hapus?',
    tip: 'Tip',
    deleted: 'Dibatalkan menghapus',
    xzskfstt: 'Tambahkan Metode Pembayaran Baru',
    xgskfstt: 'Ubah Metode Pembayaran',
    khmc: 'Nama Pemegang Akun',
    yhkh: 'Nomor Kartu Bank',
    khh: 'Bank',
    khhszd: 'Lokasi Bank',
    khhmc: 'Nama Bank',
    wxzh: 'Akun WeChat',
    zfbzf: 'Pembayaran Alipay',
    ewmsc: 'Unggah Kode QR',
    jymm: 'Kata Sandi Transaksi',
    srkhh: 'Silakan masukkan nama bank',
    xzszd: 'Silakan pilih lokasi bank',
    srkhmc: 'Silakan masukkan nama bank',
    srzh: 'Silakan masukkan nomor akun',
    scskm: 'Silakan unggah kode QR penerimaan',
    srjymm: 'Silakan masukkan kata sandi transaksi',
    scwjgd: 'Ukuran gambar unggahan tidak boleh lebih dari 2MB!',

    jnbzj1: 'Sebagai {gradeName}, Anda telah membayar jaminan {margin} USDT, sisa kuota iklan saat ini {amount} USDT',
    k: 'Dapat',
    add: 'Tambahkan',
    or: 'atau',
    reduce: 'Kurangi',
    margin: 'Jaminan',
    sqsxf: '*Platform akan membebankan biaya sebesar {fee}% dari nilai transaksi iklan kepada merchant',
    hqed: 'Segera menjadi merchant terverifikasi untuk mendapatkan kuota lebih tinggi',
    want: 'Saya ingin',
    bb: 'Spot',
    price: 'Harga',
    ckj: '*Harga referensi pasar {price} {fiatCurrency}/USDT Harga tetap tidak berfluktuasi dengan pasar',
    jyjg: 'Harga Transaksi',
    mdjg: 'Harga Anchor',
    gxhl: '*Nilai tukar real-time komprehensif dari bank dan beberapa bursa, diperbarui setiap 5 menit',
    szyj: 'Atur Premium',
    zjjy: '*Dapat memasukkan angka negatif, yaitu diskon berdasarkan harga anchor',
    yjsz: '*Harga transaksi = Harga anchor * (1 + pengaturan premium)',
    jyxz: 'Pembatasan Transaksi',
    jysl: 'Jumlah Transaksi',
    sygged: '*Jumlah transaksi tidak boleh melebihi kuota iklan yang tersisa',
    zxxe: 'Batas Minimum per Pesanan',
    zdxe: 'Batas Maksimum per Pesanan',
    fkqx: 'Batas Waktu Pembayaran',
    xnfk: '*Harus membayar dalam batas waktu ini',
    fkfs: 'Metode Pembayaran',
    xzskfs: '*Maksimal 5 metode pembayaran dapat ditambahkan untuk semua mata uang',
    yhjy: 'Tidak melakukan transaksi dengan pengguna yang belum menyelesaikan verifikasi identitas lanjutan',
    jygg: '*Pengguna yang hanya menyelesaikan verifikasi identitas dasar tidak dapat memasuki iklan transaksi',
    cyjy: 'Silakan pilih pengguna yang belum menyelesaikan jumlah pembelian tertentu, tidak dapat berpartisipasi dalam transaksi',
    bmfx: '*Pengguna yang telah menyelesaikan pembelian telah大大 mengurangi risiko sumber dana yang tidak jelas',
    qxz: 'Silakan pilih',
    jybz: 'Catatan Transaksi',
    tyzs: 'Saya mengetahui dan menyetujui untuk mematuhi',
    jygz: '《Aturan Transaksi》',
    yzm: 'Kode Verifikasi',
    save: 'Simpan',
    fbgg: 'Posting Iklan',
    jsbzjcg: 'Berhasil mengurangi jaminan',
    zjbzjcg: 'Berhasil menambah jaminan',
    xzfs: 'Silakan pilih metode pembayaran atau metode penerimaan',
    bankTip1: 'Kartu bank tidak boleh lebih dari tiga metode pembayaran',
    wxTip2: 'WeChat tidak boleh lebih dari tiga metode pembayaran',
    zfbTip3: 'Alipay tidak boleh lebih dari tiga metode pembayaran',
    syjg: 'Silakan masukkan harga',
    syjysl: 'Silakan masukkan jumlah transaksi',
    zxxe: 'Silakan masukkan batas minimum per pesanan',
    zdxe: 'Silakan masukkan batas maksimum per pesanan',
    fkqx: 'Silakan masukkan batas waktu pembayaran',
    tyjygz: 'Silakan setujui aturan transaksi',
    tpyzm: 'Silakan masukkan kode verifikasi gambar',
    jydx: 'Rekan Transaksi',

    zjbzj: 'Tambahkan Jaminan',
    jsbzj: 'Kurangi Jaminan',
    xzdgged: 'Kuota iklan maksimum saat ini',
    zjbzjse: 'Jumlah penambahan jaminan',
    jsbzjse: 'Jumlah pengurangan jaminan',
    zjhbzjed: 'Jumlah jaminan setelah penambahan',
    jshbzjed: 'Jumlah jaminan setelah pengurangan',
    balance: 'Saldo',
    sy: 'Tersisa',
    kzj: 'Dapat ditambahkan',
    kjs: 'Dapat dikurangi',
    otcsjxy: 'Peraturan Layanan Merchant OTC',
    xsgz: 'Tutorial Pemula',
    jygz: 'Aturan Transaksi',
    jnbzj: 'Untuk memastikan OTC legal dan合规, mengatur perilaku pihak terkait,因此 merchant diharuskan membayar sejumlah jaminan;',
    zjjnbzj: 'Jaminan terdiri dari dua bagian: kuota dasar dan kuota tambahan, kuota dasar adalah bagian yang harus dibayar, bagian tambahan dapat dipilih untuk dibayar atau tidak;',
    kxs: 'Membayar kuota dasar dapat menikmati',
    fbgged: 'Posting CNYT dihitung berdasarkan nilai tukar) kuota iklan;',
    ggedbl: 'Rasio bagian tambahan jaminan dengan kuota iklan adalah',
    eg: 'Misalnya menambah 100 USDT maka kuota iklan meningkat 100 x',
    ggzedjs: 'Rumus perhitungan total kuota iklan: Kuota iklan dasar + Kuota iklan tambahan x',
    ttsjzxed: 'Kuota minimum penambahan jaminan untuk merchant biasa adalah',
    zdedw: 'Kuota maksimum adalah',
    mgsjzd: 'Setiap merchant dapat memposting maksimal tiga iklan beli dan tiga iklan jual.',
    hljj: 'Nilai tukar USDT ke CNYT diambil dari harga rata-rata pasangan perdagangan terkait platform BiKing dalam 24 jam terakhir (dicatat setiap jam, dan menghilangkan harga tertinggi dan terendah), sebagai nilai tukar saat ini; dan ketika nilai tukar berfluktuasi, kuota iklan yang diposting sebelumnya tetap tidak berubah.',
    jcbzj: 'Jaminan Dasar',
    xt: 'Opsional',
    njhded: 'Kuota iklan yang akan Anda dapatkan:',
    mbye: 'Saldo Beli Koin:',
    zhzcbz: 'Aset akun tidak mencukupi, Anda dapat transfer dari akun aset',
    qhz: 'Pergi ke Transfer',
    qdjnbzj: 'Konfirmasi pembayaran jaminan dasar',
    tjbzj: 'Tambahkan Jaminan',
    sqsjcg: 'Berhasil mengajukan menjadi merchant',
    exchange: 'Pengubahan Nilai Tukar'
}
export {
    advertise
}


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/ba.js